/**
 * 首页轮播图：按语言使用不同素材。默认中英日共用同一套图；
 * 替换某一语言时，只改对应 locale 下的 require 路径即可。
 */
const LINK_IDS = ['3', '2', '3']

const imagesEn = [
  require('@/assets/banner1-1.png'),
  require('@/assets/banner1-2.png'),
  require('@/assets/banner1-3.png'),
]

const imagesZhCN = [
  require('@/assets/chineseBanner1.png'),
  require('@/assets/chineseBanner2.png'),
  require('@/assets/chineseBanner3.png'),
]

const imagesJa = [
  require('@/assets/jpBanner1.png'),
  require('@/assets/jpBanner2.png'),
  require('@/assets/jpBanner3.png'),
]

const BY_LOCALE = {
  en: imagesEn,
  'zh-CN': imagesZhCN,
  ja: imagesJa,
}

export function getHeroSlidesForLocale(locale) {
  const images = BY_LOCALE[locale] || BY_LOCALE.en
  return LINK_IDS.map((id, i) => ({
    id,
    image: images[i],
  }))
}
